import * as Styled from './page-error.styles';

type PageErrorProps = {
  errorCode?: string;
};

// oxlint-disable-next-line typescript/no-unused-vars
const PageError: React.FC<PageErrorProps> = ({ errorCode = '503' }) => {
  return (
    <Styled.Container>
      {/* <Status key={errorCode} code={parseInt(errorCode)} /> */}
      {/* <ErrorGlobal type={errorCode} /> */}
    </Styled.Container>
  );
};

export { PageError };
